import { useMemo } from 'react';
import { ErrorBoundary, PageLayout } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRoute, AppRouteWithParams } from 'routing/AppRoute.enum';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';

import { UserHistoryBar } from './userHistoryBar/UserHistoryBar';
import { UserDetailsHistoryContainer } from './userDetailsHistory/UserDetailsHistoryContainer';
import { UserPermissionsHistoryContainer } from './userPermissionsHistory/UserPermissionsHistoryContainer';

export const UserHistory = () => {
  const { formatMessage } = useLocale();

  const isUserHistoryView = useIsExactPath(AppRouteWithParams.userHistory.path);
  const isUserPermissionsHistoryView = useIsExactPath(AppRouteWithParams.userPermissionsHistory.path);

  const currentPage = useMemo<React.ReactNode>(() => {
    switch (true) {
      case isUserHistoryView:
        return <UserDetailsHistoryContainer />;
      case isUserPermissionsHistoryView:
        return <UserPermissionsHistoryContainer />;
      default:
        return null;
    }
  }, [isUserHistoryView, isUserPermissionsHistoryView]);

  return (
    <ErrorBoundary>
      <PageLayout
        header={formatMessage({ id: AppMessages['common.history'] })}
        withBackButton={{
          onClick: (navigate) => navigate(AppRoute.users),
        }}
        renderContent={() => (
          <>
            <UserHistoryBar />

            {currentPage}
          </>
        )}
      />
    </ErrorBoundary>
  );
};
